var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sad-face-block"},[_c('div',{staticClass:"danger-line"}),_vm._v(" "),_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":require("assets/icons/face.svg"),"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"danger-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }